/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {User} from '../models/User';

export interface GetUsersByIds$Request {
    requestBody: Array<number>;
}

export interface GetUsersByIds$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUsersByIdsRequest = createAction<PayloadData<void, GetUsersByIds$Request>>('GET_USERS__GET_USERS_BY_IDS__REQUEST');
export const getUsersByIdsSuccess = createAction<PayloadData<{ [key: string]: User; }, GetUsersByIds$Request>>('GET_USERS__GET_USERS_BY_IDS__SUCCESS');
export const getUsersByIdsFailure = createAction<PayloadData<Error, GetUsersByIds$Request, true>>('GET_USERS__GET_USERS_BY_IDS__FAILURE');

export const getUsersByIdsActions = [
    getUsersByIdsRequest,
    getUsersByIdsSuccess,
    getUsersByIdsFailure
] as const;

/**
 * @param {Array<number>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUsersByIds = (meta: GetUsersByIds$Request, config?: GetUsersByIds$Config) => {
    return {
        CALL_API: {
            types: getUsersByIdsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/get-by-ids`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

